// extracted by mini-css-extract-plugin
export default {"logoLink":"TopbarSimplified_logoLink__LqBrS","root":"TopbarSimplified_root__aJIZm"};